'use strict';

angular.module('schoolLinqApp').directive('checkboxDropdown', checkboxDropdown);
function checkboxDropdown() {
	const controller = [
		'$scope',
		'$q',
		'$mdMenu',
		'$timeout',
		function ($scope, $q, $mdMenu, $timeout) {
			$scope.selected = [];
			$scope.displayValue = 'ALL';

			angular.extend($scope, {
				init: function () {
					if ($scope.ngModel.length === 0 || $scope.ngModel.length === $scope.datasource.length) {
						$scope.selected = $scope.datasource.slice(0);
					}
					if ($scope.ngModel.length === 1) {
						const item = _.find($scope.datasource, function (f) {
							return f.Id === $scope.ngModel[0];
						});
						if (!_.isUndefined(item)) {
							$scope.displayValue = item.Description;
							$scope.toggle(item, $scope.selected);
						}
					}
					if ($scope.ngModel.length > 1) {
						_.each($scope.ngModel, function (i) {
							const item = _.find($scope.datasource, function (f) {
								return f.Id === i;
							});
							if (!_.isUndefined(item)) {
								$scope.toggle(item, $scope.selected);
							}
						});
					}

					$scope.setDisplayValue();
				},
				setKeyDownByTabIndex: function () {
					$timeout(function () {
						var arrays = document.getElementsByClassName('clickable');

						_.each(arrays, function (element) {
							element.tabIndex = element.rowIndex;

							element.onkeydown = function (e) {
								var idx = element.rowIndex;

								var event = window.event ? window.event : e;
								if (event.keyCode === 40) {
									//down
									idx = $('tr:focus').attr('tabindex');
									idx++;
									$('tr[tabindex=' + idx + ']').focus();
								}
								if (event.keyCode === 38) {
									//up
									idx = $('tr:focus').attr('tabindex');
									idx--;
									$('tr[tabindex=' + idx + ']').focus();
								}
							};
						});
					}, 2000);
				},
				setKeyDownEvents: function () {
					$timeout(function () {
						var tr_elements = document.getElementsByClassName('clickable');

						_.each(tr_elements, function (element) {
							element.tabIndex = element.rowIndex;
							element.onkeydown = function (e) {
								const KEY_CODE = {
									ENTER: 13,
									SPACE: 32,
									PAGE_UP: 33,
									PAGE_DOWN: 34,
									END: 35,
									HOME: 36,
									LEFT_ARROW: 37,
									UP_ARROW: 38,
									RIGHT_ARROW: 39,
									DOWN_ARROW: 40,
									TAB: 9,
									BACKSPACE: 8,
									DELETE: 46,
								};

								var idx = element.rowIndex;
								var event = window.event ? window.event : e;
								if (event.keyCode === KEY_CODE.DOWN_ARROW) {
									//down
									idx++;
									$('tr[tabindex=' + idx + ']').focus();
								}
								if (event.keyCode === KEY_CODE.UP_ARROW) {
									//up
									idx--;
									$('tr[tabindex=' + idx + ']').focus();
								}
								if (event.keyCode === KEY_CODE.SPACE || event.keyCode === KEY_CODE.ENTER) {
									idx = element.rowIndex - 1;
									$('#chk-' + idx).click();
								}
							};
						});
					}, 2000);
				},

				setDisplayValue: function () {
					if ($scope.selected.length === 0 || $scope.selected.length === $scope.datasource.length) {
						$scope.displayValue = 'ALL';
						return;
					}
					if ($scope.selected.length === 1) {
						$scope.displayValue = $scope.selected[0].Description;
						return;
					}
					if ($scope.selected.length > 1) {
						$scope.displayValue = '(' + $scope.ngModel.length + ') Selected';
						return;
					}
				},
				showDropdown: function ($mdMenu, ev) {
					const btnWidth = document.querySelectorAll('.btn-chk-dropdown')[0].clientWidth;
					$scope.checkboxMenuItemStyle = 'width: ' + (btnWidth + 6) + 'px;';
					$mdMenu.open(ev);
				},
				apply: function (ev) {},
				toggleAll: function () {
					if ($scope.selected.length === $scope.datasource.length) {
						$scope.selected = [];
					} else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
						$scope.selected = $scope.datasource.slice(0);
					}
				},
				isAllChecked: function () {
					return $scope.selected.length === $scope.datasource.length;
				},
				toggle: function (item, list) {
					var idx = list.indexOf(item);
					if (idx > -1) {
						list.splice(idx, 1);
					} else {
						list.push(item);
					}
				},
				exists: function (item, list) {
					return list.indexOf(item) > -1;
				},
				userKeyEvent: function (ev) {},
			});

			$scope.$on('$mdMenuClose', function () {
				if ($scope.isAllChecked === true) {
					$scope.ngModel = [];
				} else if ($scope.selected.length === 0) {
					$scope.ngModel = [];
					// reset selected back to all checked so if user reopens all checks are checked.
					$scope.selected = $scope.datasource.slice(0);
				} else {
					$scope.ngModel = _.map($scope.selected, function (item) {
						return item.Id;
					});
				}

				$scope.setDisplayValue();
			});

			$scope.$on('$mdMenuOpen', function () {
				$timeout(function () {
					$('tr[tabindex=0]').focus();
				}, 500);
			});
		},
	];
	return {
		restrict: 'E',
		require: 'ngModel', // integer array - if array.length === 0 then "ALL" will be displayed
		scope: {
			ngModel: '=ngModel',
			datasource: '=', // Datasource (Array of data for dropdown to display) - Columns - Id, Description are required.
			thtitle: '@', // Table Header Title
		},
		replace: false,
		template: require('@ajs/templates/directives/checkbox-dropdown.html'),
		controller: controller,
		link: function (scope, element, attrs, ngModel) {
			scope.init();
			scope.setKeyDownEvents();

			scope.$on('$mdMenuClose', function () {
				angular.element(element).find('#btnCheckDropDown').focus();
			});
		},
	};
}

angular.module('schoolLinqApp').directive('userKeyEvent', function () {
	return function (scope, element, attrs) {
		element.bind('keydown keypress', function (event) {
			if (event.which === 9) {
				scope.$apply(function () {
					scope.$eval(attrs.userKeyEvent);
					event.stopPropagation();
				});

				event.preventDefault();
			}
		});
	};
});
